import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.css'],
    standalone: true,
    imports: [FormsModule]
})
export class ToggleComponent {

    @Input() disabled: boolean = false;

    @Input() checked: boolean = false;
    @Output() checkedChange: any = new EventEmitter<boolean>();

    id: string = Math.random().toString(36).substring(2);

    clickToggle() {
        const element = document.getElementById(this.id);
        element?.click();
    }

    setChecked(value: boolean) {
        if (this.checked != value) {
            this.clickToggle();
        }
    }

    toggleChecked() {
        if(!this.disabled) {
            this.checked = !this.checked;
            this.checkedChange.emit(this.checked);
        }
    }

}
